import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class CiudadApi {
    
    static activar(id, token) {  
       return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/ciudad/activar/"+id,
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token) {  
       return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/ciudad/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getCiudadList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
        
         return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/ciudad?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getCiudad(id, token ) {  
         return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/ciudad/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static save(ciudad, token ) {          
      let ciudadEnvio = Object.assign({}, ciudad);
		let comando="POST";
		if (ciudadEnvio.id > 0) {
			comando="PUT";			
		} 
		ciudadEnvio=JSON.stringify(ciudadEnvio);
		return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/ciudad/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: ciudadEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
    
    static getCiudadCombo(token ) {

		return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/ciudad/combo/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
     

    
}